import createResizeablePlugin from '@draft-js-plugins/resizeable';

export const resizeablePlugin = createResizeablePlugin();
